import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';

@Component({
    selector: 'app-date-picker',
    imports: [FormsModule, DatePicker],
    templateUrl: './date-picker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatePickerComponent {
    selectedDate = model<Date | null | undefined>();

    id = input<string>('datePicker');
    placeholder = input<string | undefined>('Select a date');

    invalid = input<boolean>(false);
    disabled = input<boolean>(false);

    minDate = input<Date | null>();
    maxDate = input<Date | null>();
    disabledDates = input<Date[]>([]);

    blur = output();

    isInvalid = computed(() => this.invalid() && !this.disabled());

    handleChange(selectedDate: Date | null) {
        this.selectedDate.set(selectedDate);
    }
}
